export function createRandomInt(min = 1, max = 10_000_000) {
  const roundedMin = Math.ceil(min);
  const roundedMax = Math.floor(max);

  return Math.floor(Math.random() * (roundedMax - roundedMin + 1) + roundedMin);
}
